import React, { Component, Fragment } from "react";
import deleteicon from "../../static/images/deleteicon.png";
import document from "../../static/images/document.png";
import play from "../../static/images/play.png";
import styles from "./index.less";

interface Props {
  name?: string;
  size?: string;
  type: number | string;
  path?: string;
  source?: string;
  fieldName?: string;
  showUrl?:string;
  grayType?: boolean;
  deleteDocument?: (attachmentPath: string, field?: string) => void;
}

// const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
class Attachment extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  renderAttachment() {
    const {
      name,
      size,
      type,
      path,
      deleteDocument,
      source,
      fieldName,
      grayType,
      showUrl
    } = this.props;

    switch (type) {
      case 3:
        return (
          <div className={styles.attachment}>
            <div className={styles.info}>
              <img src={document} className={styles.document} />
              <span className={styles.name}>{name}</span>
            </div>
            {source !== "detail" ? (
              <Fragment>
                <span className={styles.size}>{size}M</span>
                <span className={styles.status}>上传成功</span>
                <img
                  src={deleteicon}
                  className={styles.deleteicon}
                  style={{ pointerEvents: grayType ? "none" : null }}
                  onClick={() => deleteDocument(path, fieldName)}
                />
              </Fragment>
            ) : null}
          </div>
        );
      case 1:
        return (
          <div className={styles.image}>
            {
              <Fragment>
                <img src={showUrl?showUrl:path} className={styles.pic} />
                {source !== "detail" ? (
                  <img
                    src={deleteicon}
                    className={styles.deleteicon}
                    style={{ pointerEvents: grayType ? "none" : null }}
                    onClick={() => {
                      deleteDocument(path, fieldName);
                    }}
                  />
                ) : null}
              </Fragment>
            }
          </div>
        );

      case 2:
        return (
          <div className={styles.video}>
            {
              <Fragment>
                <video src={showUrl?showUrl:path}></video>
                {source !== "detail" ? (
                  <img
                    src={deleteicon}
                    className={styles.deleteicon}
                    style={{ pointerEvents: grayType ? "none" : null }}
                    onClick={() => {
                      deleteDocument(path, fieldName);
                    }}
                  />
                ) : null}
                <img src={play} className={styles.play} />
              </Fragment>
            }
          </div>
        );
      default:
        console.log("类型未命中", type);
        return null;
    }
  }

  render() {
    return this.renderAttachment();
  }
}

export default Attachment;
